import React, { FC, ReactElement } from 'react';
import {QueryFilter} from "../../../components/DataTable/Filters/types";
import {DataTable} from "../../../components/DataTable/DataTable";
import {useParams} from "react-router-dom";
import {ColumnsType} from "antd/lib/table";
import {StudentExerciseAttempt} from "../../../types";
import moment from "moment";
import {DATATABLE_VERTICAL_SCROLL, DATETIME_FORMAT} from "../../../constants";
import isNumeric from "antd/lib/_util/isNumeric";
import {useOrganisation} from "../../../layout/OrganisationInformationProvider";
import {PreserveQueryLink as Link} from "../../../components/PreserveQueryLink";


export const renderActivityScore = (value: any, record: StudentExerciseAttempt ) => {
    if(!record.completed_datetime) {
        return "In progress"
    }
    if(isNumeric(value)) {
        return `${value}%`
    }
    return record.passed ? 'Passed' : 'Not passed'
}
const columns = (canViewIndividualData: boolean): ColumnsType<StudentExerciseAttempt> => [
    {
        title: 'Activity',
        dataIndex: ['activity', 'title'],
        key: 'activity.title',
        render: (text, record) => {
            return record.completed_datetime
                ? <Link to={`activity/${record.student_activity}/${record.id}`}>{text}</Link>
                : text
        }
    },
    ...(canViewIndividualData ? [{
        title: 'Score',
        dataIndex: 'score',
        key: 'score',
        sorter: true,
        render: renderActivityScore
    }] : []) as ColumnsType<StudentExerciseAttempt>,
    {
        title: 'Date Started',
        dataIndex: 'started_datetime',
        key: 'started_datetime',
        sorter: true,
        sortDirections: ['ascend', 'descend', 'ascend'],
        defaultSortOrder: 'descend',
        render: (value) => moment(value).format(DATETIME_FORMAT)
    }
]

export const RecentActivityAttemptsDataTable: FC = (): ReactElement => {
    const {id} = useParams();
    const {can_view_individual_data: canViewIndividualData} = useOrganisation();
    const tableColumns = columns(canViewIndividualData);
    return (
        <DataTable
            columns={tableColumns}
            defaultFilters={{
                student: id || '', 
                fields: canViewIndividualData
                    ? 'id,activity,score,started_datetime,completed_datetime,passed,student_activity'
                    : 'id,activity,started_datetime,completed_datetime,student_activity',
                ordering: '-started_datetime'
            }}
            searchParamFilters={[QueryFilter.COURSES, QueryFilter.COHORTS]}
            query='/reports/student-exercise-attempts/'
            pagination={false}
            scroll={DATATABLE_VERTICAL_SCROLL}
        />
    );
};
